import React from "react";
import Section from "./Section";

export default function TableOfContents({ name, url, children, className = ""}) {
  return (
    <div id="toc" className="w-full sticky -top-[1px] z-40 bg-white bg-opacity-20 backdrop-blur border-t border-b border-dashed border-gray overflow-x-auto">
      <Section className="!mb-0 py-2 md:py-0 px-0 sm:px-4">
        <ul className={`flex w-full max-w-full text-base md:-ml-4 mx-auto md:space-x-4 ${className}`}>
          {children}
        </ul>
      </Section>
    </div>
  );
}
